// extracted by mini-css-extract-plugin
export default {"button":"quiz-module--button--2lWs3","results":"quiz-module--results--33DRX","result":"quiz-module--result--cLzon","picture":"quiz-module--picture--3JNeA"};